export class DialogModelCustomizeConfirm {
    constructor(
      public obj: any
    ) {}
  }
  